import { render, staticRenderFns } from "./private.vue?vue&type=template&id=91bcf068&scoped=true"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"
import style0 from "./private.vue?vue&type=style&index=0&id=91bcf068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bcf068",
  null
  
)

export default component.exports